// extracted by mini-css-extract-plugin
export default {"container":"PortalBody__container__FJEq1","noFooter":"PortalBody__noFooter__rRqL3"};